// extracted by mini-css-extract-plugin
module.exports = {"x-post":"XPost_x-post__BDj4b","frame":"XPost_frame__vMcHt","skeleton":"XPost_skeleton__7f9ik"};